import { useLazyQuery } from '@apollo/client';
import {
  DocumentsQueryActions,
  GetSignedUrlT,
} from '@contexts/IdentityValidation/domain/ports/documents-query-actions.port';
import { GetSignedUrlQuery } from '@contexts/IdentityValidation/domain/queries/get-signed-url.query';
import { AptunoApolloLink, ResponseApolloErrorMapping } from '@contexts/Shared';

import { GetSignedUrlRequestDto, GetSignedUrlResponseDto } from '../dtos/documents.dto';
import { getSignedUrl } from '../schemas/queries/get-signed-url.query';

export const GqlDocumentsQueryActions: DocumentsQueryActions = {
  useGetSignedUrl: (): GetSignedUrlT => {
    const [action, { data, loading, error, refetch }] = useLazyQuery<GetSignedUrlResponseDto, GetSignedUrlRequestDto>(
      getSignedUrl,
      {
        errorPolicy: 'all',
        context: { clientName: AptunoApolloLink.CREDIT_STUDY },
      }
    );

    const mapRecalling = (): Promise<string | undefined> =>
      (refetch && refetch().then((response) => response.data?.getSignedUrlForIdentityValidationDocument.value)) ||
      Promise.resolve(undefined);

    return {
      loading,
      recall: mapRecalling,
      error: error && ResponseApolloErrorMapping(error),
      signedUrl: data?.getSignedUrlForIdentityValidationDocument?.value,
      getSignedUrl: (query: GetSignedUrlQuery) => {
        action({
          variables: {
            identityValidationId: query.identityValidationId,
            document: query.document,
          },
        });
      },
    };
  },
};
